import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import SettingsTabs from '../../components/common/SettingsTabs';
import { faLinkedin, faSquareFacebook, faSquareInstagram } from '@fortawesome/free-brands-svg-icons';
import { toast } from 'react-toastify';
import { apiService } from '../../services/apiService';
function SettingsSocialLink() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        facebook_link: '',
        instagram_link: '',
        linkedin_link: '',
    });
    const [errors, setErrors] = useState({});
    const [cancel, setCancels] = useState(false);
    const [btnloading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorsmessage, setErrorMessage] = useState('');
    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const response = await apiService.postRequest(`/admin/get-protected-settings?settings_type=social_links`);
                const generaldata = response.data;
                setFormData({
                    facebook_link: generaldata.facebook_link || '',
                    instagram_link: generaldata.instagram_link || '',
                    linkedin_link: generaldata.linkedin_link || '',
                });
            } catch (error) {
                console.error("Error fetching user data", error);
            }finally {
                setCancels(false);
                setLoading(false);
            }
        };

        fetchUserData();
    }, [cancel]);
    // Clear specific errors when inputs are modified
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Clear the error for the changed field
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append('facebook_link', formData.facebook_link);
        data.append('instagram_link', formData.instagram_link);
        data.append('linkedin_link', formData.linkedin_link);
        
        // if (formData.site_logo) {
        // }

        setBtnLoading(true);
        try {
            const response = await apiService.postRequest('/admin/save-social-settings', data);
            if (response && response.success === true) {
                // navigate('/user/member');
                toast(response.message || "Settings saved successfully!");
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error adding user:', error);
        } finally {
            setBtnLoading(false);
        }
    }; 
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Company Settings</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Company Settings <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Social Links</span>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn my-5">
                        <SettingsTabs/>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center">
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                            <Grid size={{sm:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                <Grid size={{sm:12, xs:12}} container alignItems="flex-end" justifyContent="space-evenly">
                                    <Grid container justifyContent="center">
                                        <FontAwesomeIcon className='icon_setting' icon={faSquareFacebook} />
                                    </Grid>
                                    <Grid size={{sm:11, xs:10}} container flexDirection="column" >
                                        <span>Facebook<small className='red_starimpo'>*</small></span>
                                        <input type="url" name="facebook_link" value={formData.facebook_link} onChange={handleInputChange} />
                                        {errors.facebook_link && <p style={{color:"red"}}>{errors.facebook_link}</p>}
                                    </Grid>
                                </Grid>
                                <Grid size={{sm:12, xs:12}} container alignItems="flex-end" justifyContent="space-evenly">
                                    <Grid container justifyContent="center">
                                        <FontAwesomeIcon className='icon_setting' icon={faSquareInstagram} />
                                    </Grid>
                                    <Grid size={{sm:11, xs:10}} container flexDirection="column" >
                                        <span>Instagram<small className='red_starimpo'>*</small></span>
                                        <input type="url" name="instagram_link" value={formData.instagram_link} onChange={handleInputChange}/>
                                        {errors.instagram_link && <p style={{color:"red"}}>{errors.instagram_link}</p>}
                                    </Grid>
                                </Grid>
                                <Grid size={{sm:12, xs:12}} container alignItems="flex-end" justifyContent="space-evenly">
                                    <Grid container justifyContent="center">
                                        <FontAwesomeIcon className='icon_setting' icon={faLinkedin} />
                                    </Grid>
                                    <Grid size={{sm:11, xs:10}} container flexDirection="column" >
                                        <span>LinkedIn<small className='red_starimpo'>*</small></span>
                                        <input type="url" name="linkedin_link" value={formData.linkedin_link} onChange={handleInputChange}/>
                                        {errors.linkedin_link && <p style={{color:"red"}}>{errors.linkedin_link}</p>}
                                    </Grid>
                                </Grid>
                            {errorsmessage && <p style={{ color: 'red' }}>{errorsmessage}</p>}
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container className="gap-3 my-3">
                                <button type='button' className='registersendbtn1' onClick={()=>setCancels(true)}>Cancel</button>
                                <button type="submit" className='registersendbtn2'>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                            </Grid>
                        </form>
                    </>}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default SettingsSocialLink
